module.exports = __webpack_public_path__ + "a2314fc9/img/attach-icon.2200b7fc.svg";